'use strict';

var _tuner = require('./tuner');

var _tuner2 = _interopRequireDefault(_tuner);

var _nowPlayingPoller = require('./nowPlayingPoller');

var _nowPlayingPoller2 = _interopRequireDefault(_nowPlayingPoller);

var _idle = require('./states/idle');

var _idle2 = _interopRequireDefault(_idle);

var _loading = require('./states/loading');

var _loading2 = _interopRequireDefault(_loading);

var _loaded = require('./states/loaded');

var _loaded2 = _interopRequireDefault(_loaded);

var _connecting = require('./states/connecting');

var _connecting2 = _interopRequireDefault(_connecting);

var _playing = require('./states/playing');

var _playing2 = _interopRequireDefault(_playing);

var _paused = require('./states/paused');

var _paused2 = _interopRequireDefault(_paused);

var _stopped = require('./states/stopped');

var _stopped2 = _interopRequireDefault(_stopped);

var _waiting = require('./states/waiting');

var _waiting2 = _interopRequireDefault(_waiting);

var _failed = require('./states/failed');

var _failed2 = _interopRequireDefault(_failed);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_tuner2.default.states = {
  idle: _idle2.default,
  loading: _loading2.default,
  loaded: _loaded2.default,
  connecting: _connecting2.default,
  playing: _playing2.default,
  paused: _paused2.default,
  stopped: _stopped2.default,
  waiting: _waiting2.default,
  failed: _failed2.default
};

_tuner2.default.state = _tuner2.default.states.idle;
_tuner2.default.fetchCurrentNowPlaying = function (guideId) {
  return _nowPlayingPoller2.default.fetchCurrentNowPlaying(guideId);
};

module.exports = _tuner2.default;
//# sourceMappingURL=index.js.map